<template>
  <div class="container">
    <div class="head_bg">
      <comm-head></comm-head>
      <div class="head_con">
        <img src="../assets/images/img_john.png" alt />
        <div></div>
        <div>
          <p>人人有爱，公益助学</p>
          <p>致力于传播人人有爱的文化愿景，用更多的爱暖更多的心，更多的心聚更多的爱。同时提倡公益助学，为中国教育事业的发展贡献力量。</p>
        </div>
      </div>
    </div>
    <div class="bg_w">
      <div>
        <h1>麦乐会理事</h1>
        <p>2013年1月1日，徐俊先生创立启动了麦乐会。麦乐会是独立的公益组织，严格按照国家法律及《章程》进行管理。理事会是最高决策机构，麦乐会理事会在原有28人的基础上,2018年又重新招募十三位新的理事，且规范了麦乐会的组织职能。目前在职理事22人，包括 John Susan Bella Pascale Alice Cherry Lucio Gemini Stone Cora Leo Xixi Janna Blue Maple.hc Lisa Bart Peter.Wan Dorae Kyrie Emily Sherry</p>
        <div class="pictures">
          <div
            class="bubble_base avatar_0"
            @mouseenter="handleBubbleMouseEnter(0)"
            @mouseleave="handleBubbleMouseLeave(0)"
            style="width:97px;height:101px;top:156px;left:60px;"
          >
            <div :class="{'bubble_top_0':bubble['0']}" class="bubbble_shadow" style="top:101px"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['0']}"
              style="font-size: 16px;"
            >
              <span>Susan</span>
              <span style="font-size:10px;">荣誉会长</span>
            </div>
          </div>
          <div
            class="bubble_base avatar_1"
            @mouseenter="handleBubbleMouseEnter(1)"
            @mouseleave="handleBubbleMouseLeave(1)"
            style="width:136px;height:140px;top:229px;left:213px;"
          >
            <div :class="{'bubble_top_0':bubble['1']}" class="bubbble_shadow" style="top:140px;"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['1']}"
              style="font-size: 24px;"
            >
              <span>Cherry</span>
              <span style="font-size:18px;">财务审核</span>
            </div>
          </div>
          <div
            class="bubble_base avatar_2"
            @mouseenter="handleBubbleMouseEnter(2)"
            @mouseleave="handleBubbleMouseLeave(2)"
            style="width:189px;height:196px;top:64px;left:459px;"
          >
            <div :class="{'bubble_top_0':bubble['2']}" class="bubbble_shadow" style="top:196px;"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['2']}"
              style="font-size: 24px;"
            >
              <span>Bella</span>
              <span style="font-size:18px;">会长</span>
            </div>
          </div>
          <div
            class="bubble_base avatar_3"
            @mouseenter="handleBubbleMouseEnter(3)"
            @mouseleave="handleBubbleMouseLeave(3)"
            style="width:97px;height:101px;top:281px;left:623px;"
          >
            <div :class="{'bubble_top_0':bubble['3']}" class="bubbble_shadow" style="top:101px;"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['3']}"
              style="font-size: 16px;"
            >
              <span>John</span>
              <span style="font-size:10px;">荣誉会长</span>
            </div>
          </div>
          <div
            class="bubble_base avatar_4"
            @mouseenter="handleBubbleMouseEnter(4)"
            @mouseleave="handleBubbleMouseLeave(4)"
            style="width:120px;height:124px;top:113px;left:727px;"
          >
            <div :class="{'bubble_top_0':bubble['4']}" class="bubbble_shadow" style="top:124px;"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['4']}"
              style="font-size: 18px;"
            >
              <span>Pascale</span>
              <span style="font-size:12px;">副会长</span>
            </div>
          </div>
          <div
            class="bubble_base avatar_5"
            @mouseenter="handleBubbleMouseEnter(5)"
            @mouseleave="handleBubbleMouseLeave(5)"
            style="width:70px;height:72px;top:175px;left:946px;"
          >
            <div :class="{'bubble_top_0':bubble['5']}" class="bubbble_shadow" style="top:72px;"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['5']}"
              style="font-size: 2px;"
            >
              <span>Lucio</span>
              <span style="font-size:0.2px;">大学部部长</span>
            </div>
          </div>
          <div
            class="bubble_base avatar_6"
            @mouseenter="handleBubbleMouseEnter(6)"
            @mouseleave="handleBubbleMouseLeave(6)"
            style="width:84px;height:90px;top:304px;left:847px;"
          >
            <div :class="{'bubble_top_0':bubble['6']}" class="bubbble_shadow" style="top:90px;"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['6']}"
              style="font-size: 14px;"
            >
              <span>Stone</span>
              <span style="font-size:8px;">大家部部长</span>
            </div>
          </div>
          <div
            class="bubble_base avatar_7"
            @mouseenter="handleBubbleMouseEnter(7)"
            @mouseleave="handleBubbleMouseLeave(7)"
            style="width:136px;height:140px;top:304px;left:412px;"
          >
            <div :class="{'bubble_top_0':bubble['7']}" class="bubbble_shadow" style="top:140px;"></div>
            <div
              class="bubble_content"
              :class="{'bubble_opac_1':bubble['7']}"
              style="font-size: 24px;"
            >
              <span>Alice</span>
              <span style="font-size:18px;">秘书长</span>
            </div>
          </div>
          <div
            class="b_c_o opac_11 bubble_base"
            style="width:44px;height:44px;top:329px;left:138px;"
          ></div>
          <div
            class="b_c_o opac_34 bubble_base"
            style="width:25px;height:25px;top:193px;left:323px;"
          ></div>
          <div class="b_c_o bubble_base" style="width:36px;height:36px;top:348px;left:752px;"></div>
          <div class="b_c_g bubble_base" style="width:50px;height:50px;top:306px;left:994px;"></div>
          <div
            class="b_c_o opac_34 bubble_base"
            style="width:25px;height:25px;top:193px;left:1115px;"
          ></div>
        </div>
        <h1>新闻动态</h1>
        <div class="news_carousel">
          <el-carousel
            ref="carousel"
            height="320px"
            @change="handleCarouselChange"
            :interval="8000"
            arrow="never"
          >
            <el-carousel-item
              v-for="(item,index) in newsList"
              :key="index"
              :name="index.toString()"
            >
              <div class="news_carousel_item">
                <img :src="item.Img" alt />
                <div>
                  <h2>{{item.Name}}</h2>
                  <p>{{item.Summary}}</p>
                  <div>
                    <span>{{item.CreateTime}}</span>
                    <div @click="handleDetails(item.id)">
                      <i class="el-icon-plus"></i>
                      查看详情
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="news_list">
            <div
              class="news_list_items"
              @click="handleCarousel(index)"
              v-for="(item,index) in newsList"
              :key="index"
              :style="{'backgroundImage':'url('+ item.Img+')','opacity':currentCarousel==index?1:0.8}"
            ></div>
          </div>
        </div>
        <h1>公益足迹</h1>
        <div class="certificate">
          <el-carousel height="233px" indicator-position="none" :interval="5000" arrow="never">
            <el-carousel-item>
              <div class="carousel_item">
                <img src="../assets/images/mlh_honor_1.png" alt />
                <img src="../assets/images/mlh_honor_2.png" alt />
                <img src="../assets/images/mlh_honor_3.png" alt />
                <img src="../assets/images/mlh_honor_4.png" alt />
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel_item">
                <img src="../assets/images/mlh_honor_5.png" alt />
                <img src="../assets/images/mlh_honor_6.png" alt />
                <img src="../assets/images/mlh_honor_7.png" alt />
                <img src="../assets/images/mlh_honor_8.png" alt />
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel_item">
                <img src="../assets/images/mlh_honor_9.png" alt />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <foot-cpright></foot-cpright>
  </div>
</template>

<script>
import commHead from "@/components/comm-head.vue";
import footCpright from "@/components/foot-cpright.vue";
export default {
  components: {
    commHead,
    footCpright
  },
  data() {
    return {
      bubble: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false
      },
      currentCarousel: null,
      newsList: []
    };
  },
  created() {
    const { getData } = this;
    getData();
  },
  methods: {
    getData() {
      this.$http.get("/site/mlh").then(response => {
        response.d.forEach(res => {
          res.id =
            res.Link.includes("?") && res.Link.split("?")[1].split("=")[1];
        });
        this.newsList = response.d;
      });
    },
    handleBubbleMouseEnter(index) {
      this.bubble[index] = true;
    },
    handleBubbleMouseLeave(index) {
      this.bubble[index] = false;
    },
    handleCarouselChange(index) {
      this.currentCarousel = index;
    },
    handleDetails(id) {
      this.$router.push({ name: "Details", query: { id } });
    },
    handleCarousel(index) {
      this.currentCarousel = index;
      this.$refs.carousel.setActiveItem(index);
    }
  }
};
</script>

<style lang="scss" scoped>
.b_c_o {
  background-color: #ff9200;
}
.b_c_g {
  background-color: #d8d8d8;
}

.opac_11 {
  opacity: 0.11;
}
.opac_34 {
  opacity: 0.34;
}

.avatar_0 {
  background-image: url("../assets/images/mlh_ls1.png");
}
.avatar_1 {
  background-image: url("../assets/images/mlh_ls2.png");
}
.avatar_2 {
  background-image: url("../assets/images/mlh_ls3.png");
}
.avatar_3 {
  background-image: url("../assets/images/mlh_ls4.png");
}
.avatar_4 {
  background-image: url("../assets/images/mlh_ls5.png");
}
.avatar_5 {
  background-image: url("../assets/images/mlh_ls6.png");
}
.avatar_6 {
  background-image: url("../assets/images/mlh_ls7.png");
}
.avatar_7 {
  background-image: url("../assets/images/mlh_ls8.png");
}

.bubble_base {
  position: absolute;
  border-radius: 50%;
  overflow: hidden;
}

.bubbble_shadow {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  transition: top 2s;
}

.bubble_top_0 {
  top: 0px !important;
}
.bubble_opac_1 {
  opacity: 1 !important;
}
.bubble_content {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity 2s;
  opacity: 0;
}

.container {
  & .head_bg {
    height: 480px;
    background-image: url("../assets/images/banner_mlh.png");
    & .head_con {
      width: 1200px;
      height: 392px;
      position: relative;
      margin: 0 auto;
      & img {
        width: 250px;
        height: 350px;
        position: absolute;
        top: 42px;
        animation: head_img_opac 5s;
      }
      & > div:nth-child(2) {
        width: 38px;
        height: 30px;
        background-image: url("../assets/images/fuhao.png");
        background-repeat: no-repeat;
        background-size: 100%;
        position: absolute;
        top: 120px;
        left: 282px;
        opacity: 0.64;
        font-family: Arial-BoldMT;
        animation: textcomein_1 2s;
        font-size: 88px;
        color: #ffffff;
        letter-spacing: 0;
      }
      & > div:last-child {
        position: absolute;
        top: 144px;
        left: 342px;
        color: #fff;
        animation: textcomein 2s;
        & p:first-child {
          width: 560px;
          font-size: 40px;
          letter-spacing: 0;
          line-height: 48px;
          margin-bottom: 16px;
        }
        & p:last-child {
          width: 800px;
          font-size: 18px;
          letter-spacing: 0;
          line-height: 32px;
        }
      }
    }
  }
  & .bg_w {
    background-color: #fff;
    padding-bottom: 80px;
    & > div {
      width: 1200px;
      margin: 0 auto;
      padding-top: 80px;
      & h1 {
        margin-bottom: 32px;
      }
      & p {
        font-size: 18px;
        color: #666;
        letter-spacing: 0;
        line-height: 32px;
      }
      & .pictures {
        height: 444px;
        position: relative;
        margin-bottom: 80px;
      }

      & .news_carousel {
        margin-bottom: 80px;
        & /deep/ .el-carousel {
          margin-bottom: 25px;
          & .el-carousel__indicators {
            left: 46%;
          }
          & .is-active > .el-carousel__button {
            background-color: #ff9200;
          }
          & .news_carousel_item {
            display: flex;
            & img {
              width: 650px;
              height: 320px;
              display: block;
              margin-right: 24px;
            }

            & > div {
              width: 526px;
              & > h2 {
                margin-bottom: 32px;
                height: 64px;
              }
              & > p {
                height: 83px;
                font-size: 18px;
                color: #666666;
                letter-spacing: 0;
                line-height: 28px;
                margin-bottom: 92px;
                overflow: hidden;
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                -webkit-box-orient: vertical;
                box-orient: vertical;
                -webkit-line-clamp: 3;
                line-clamp: 3; //显示的行数
                overflow: hidden;
                text-overflow: ellipsis;
              }
              & > div {
                display: flex;
                justify-content: space-between;
                align-items: center;
                & > span {
                  font-size: 16px;
                  color: #999999;
                  letter-spacing: 0;
                }
                & > div {
                  width: 122px;
                  height: 39px;
                  box-sizing: border-box;
                  text-align: center;
                  line-height: 39px;
                  color: #ff9200;
                  border: 1px solid #ff9200;
                  cursor: pointer;
                }
                & > div:hover {
                  color: #fff;
                  background-color: #ff9200;
                }
              }
            }
          }
        }
        & .news_list {
          display: flex;
          & .news_list_items {
            width: 220px;
            height: 116px;
            display: block;
            margin-right: 25px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          & .news_list_items:last-child {
            margin-right: 0px;
          }
        }
      }

      & .certificate {
        height: 233px;
        & .carousel_item {
          width: 100%;
          height: 100%;
          display: flex;

          & > img {
            margin-right: 30px;
          }
          & > img:last-child {
            margin-right: 0px;
          }
        }
      }
    }
  }
}

@keyframes textcomein {
  0% {
    opacity: 0;
    top: 0px;
  }
  100% {
    opacity: 1;
    top: 144px;
  }
}
@keyframes textcomein_1 {
  0% {
    opacity: 0;
    top: 0px;
  }
  100% {
    opacity: 0.64;
    top: 120px;
  }
}
</style>